// Транзишен между экранами: каждый route-элемент оборачивается в этот компонент
// (см. renderScreen в router/index.tsx). При переходе react-router монтирует новый
// элемент — CSS-анимация входа (мягкий scale, как на iOS) проигрывается на mount.
// Таб-бар и layout-роуты не анимируются: обёртка стоит только на leaf-экранах.

import { useStartupReady } from '@shared-ui/components/app/startup-transition'
import styles from '@web/router/transition/view.module.css'
import { type PropsWithChildren, useEffect } from 'react'

export function RouteTransitionView({ children, animate = true }: PropsWithChildren<{ animate?: boolean }>) {
  const markReady = useStartupReady()
  useEffect(markReady, [markReady])

  return <div className={animate ? styles.screen : `${styles.screen} ${styles.still}`}>{children}</div>
}
